// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_hs-0";
export var optionCard = "_hs-1";